import React from "react"
import Paper from "material-ui/Paper"
import Tabs from "material-ui/Tabs"
import Tab from "material-ui/Tabs/Tab"
import EmployeeTimecard from "../../../components/timecard/EmployeeTimecard"
import UserDetailsDevice from "./UserDetailsDevice"
import UserDetailsPositions from "./UserDetailsPositions"
import UserDetailsHierarchyTable from "./UserDetailsHierarchyTable"
import AccountStore from "../../../stores/AccountStore"
import UserDetailsFaceSpaces from "./UserDetailsFaceSpaces"
import strings from "../../../localization/strings"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { browserHistory } from "react-router"
import autobind from "class-autobind"
import UserDetailAccruals from "./UserDetailAccruals"
import UserDetailLeaveTracking from "./UserDetailLeaveTracking"
import UserDetailSchedule from "./UserDetailSchedule"
import { ELoggedInUserType, IUserDocument, IHolidayInstanceForPunch, EDayOfWeek, IFaceSpace } from "../../../models"
import * as userActions from "../../../actions/UserActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import UserDetailWorkPreferences from "./UserDetailWorkPreferences"
import * as timecardHelper from "../../../helpers/timecardHelper"
import UserDetailExpenses from "./UserDetailExpenses"
import UserDetailsRecord from "./UserDetailsRecord"
import UserDetailsJobs from "./UserDetailsJobs"
import UserDetailsFiles from "./UserDetailsFiles"
import * as userHelper from "../../../helpers/userHelper"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"

interface IProps {
	userId: string
	user: IUserDocument
	timecardReadOnly: boolean
	timecardApprovals: boolean
	editDevicePermission: boolean
	addDevicePermission: boolean
	deleteDevicePermission: boolean
	readonly: boolean
	readonlyForHierarchy: boolean
	tabActive: string
	loggedInUserType: ELoggedInUserType
	readonlyForIndependentPermission: boolean
	readonlySchedule: boolean
	supervisorReadonlyForSelf?: boolean
	holidays: IHolidayInstanceForPunch[]
	onUpdateProfilePic?(userId: string, faceSpace: IFaceSpace): void

	reloadTimecard?: boolean //web punch need reload timecard

	//when url has referenceDate as search param, we should use it.
	timecardReferenceDate?: string
}
interface IState {
	tabActive: string
}

export default class UserDetailsData extends React.PureComponent<IProps, IState> {
	private timecardStartDay: EDayOfWeek
	constructor(props) {
		super(props)
		this.timecardStartDay = timecardHelper.getTimecardStartDay(props.user)
		this.state = {
			tabActive: props.tabActive || "timecards",
		}
		autobind(this)
	}

	componentWillReceiveProps(nextProps: IProps) {
		this.props.tabActive !== nextProps.tabActive &&
			this.setState({ tabActive: nextProps.tabActive })
	}

	render() {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return null

		return (
			<Paper zDepth={1} style={{ textAlign: "left", margin: 20, marginTop: 20 }}>
				<Tabs
					value={!AccountStore.getTimecardEnabled() && this.state.tabActive === "timecards" ? "positions" : this.state.tabActive}
					onChange={tabActive => {
						this.setState({ tabActive })
						browserHistory.push(this.props.loggedInUserType === ELoggedInUserType.Employee ? "/es/" + tabActive : "/user-details/" + this.props.userId + "/" + tabActive)
					}}
				>
					{AccountStore.getTimecardEnabled() &&
						(this.props.loggedInUserType === AuthenticationStore.LoggedInUserTypes.Employee ||
							(this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee &&
								permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ViewTimecards))) &&
						<Tab data-intercom-target={"menu-Employees-Timecards"} label="timecards" value="timecards">
							{this.state.tabActive === "timecards" &&
								<EmployeeTimecard
									userId={this.props.userId}
									user={this.props.user}
									readonly={this.props.timecardReadOnly}
									timecardApprovals={this.props.timecardApprovals}
									loggedInUserType={this.props.loggedInUserType}
									reloadTimecard={this.props.reloadTimecard}
									referenceDate={this.props.timecardReferenceDate}
								/>
							}
						</Tab>
					}
					{AccountStore.getJobsEnabled() &&
						this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee &&
						<Tab data-intercom-target={"menu-Employees-Jobs"} label={checkJobFieldAvailable('plural') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel : strings.Jobs} value="employee_jobs">
							{this.state.tabActive === "employee_jobs" &&
								<UserDetailsJobs
									user={this.props.user}
								/>
							}
						</Tab>
					}
					<Tab data-intercom-target={"menu-Employees-Positions"} label={checkPositionFieldAvailable('plural') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel : strings.Positions} value="positions">
						{this.state.tabActive === "positions" &&
							<div className="detail-tab">
								<UserDetailsPositions
									user={this.props.user}
									readonly={this.props.readonly}
									loggedInUserType={this.props.loggedInUserType}
								/>
							</div>
						}
					</Tab>
					{AccountStore.getExpensesEnabled() &&
						(this.props.loggedInUserType === ELoggedInUserType.Employee ||
							permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewEmployeeExpense)) &&
						<Tab data-intercom-target={"menu-Employees-Expenses"} label={strings.Expenses} value="expenses">
							{this.state.tabActive === "expenses" &&
								<div className="detail-tab">
									<UserDetailExpenses
										loggedInUserType={this.props.loggedInUserType}
										user={this.props.user}
										readonly={this.props.readonlyForIndependentPermission}
									/>
								</div>
							}
						</Tab>
					}
					{AccountStore.getScheduleEnabled() &&
						(this.props.loggedInUserType === ELoggedInUserType.Employee ||
							permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewUserSchedule)) &&
						<Tab data-intercom-target={"menu-Employees-Schedules"} label={strings.Schedules} value="schedules">
							{this.state.tabActive === "schedules" &&
								<div className="detail-tab">
									<UserDetailSchedule
										userId={this.props.user.Id}
										scheduleStartDay={this.timecardStartDay}
										loggedInUserType={this.props.loggedInUserType}
										readonly={this.props.readonlySchedule}
										holidays={this.props.holidays}
									/>
								</div>
							}
						</Tab>
					}
					{AccountStore.getExplicitEmployeeHierarchyAssignment() && AccountStore.getHierarchyEnabled() &&
						<Tab data-intercom-target={"menu-Employees-Hierarchies"} label={strings.Hierarchies} value="hierarchies">
							{this.state.tabActive === "hierarchies" &&
								<div className="detail-tab">
									<UserDetailsHierarchyTable
										user={this.props.user}
										readonly={this.props.readonlyForHierarchy}
									/>
								</div>
							}
						</Tab>
					}
					{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
						(this.props.loggedInUserType === AuthenticationStore.LoggedInUserTypes.Employee ||
							permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.ViewUserLeaveTracking)
						) &&
						<Tab data-intercom-target={"menu-Employees-LeaveTracking"} label={[<div key="top">{strings.Leave_Tracking.split(" ")[0]}</div>, <div key="bottom">{strings.Leave_Tracking.split(" ")[1]}</div>]} value='leave_tracking'>
							{this.state.tabActive === "leave_tracking" &&
								<div className="detail-tab">
									<UserDetailLeaveTracking
										employee={this.props.user}
										loggedInUserType={this.props.loggedInUserType}
										holidays={this.props.holidays}
									/>
								</div>
							}
						</Tab>
					}
					{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
						(this.props.loggedInUserType === AuthenticationStore.LoggedInUserTypes.Employee ||
							permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.ViewUserAccrual)
						) &&
						<Tab data-intercom-target={"menu-Employees-Accruals"} label={strings.Accruals} value='accruals'>
							{this.state.tabActive === "accruals" &&
								<div className="detail-tab">
									<UserDetailAccruals
										user={this.props.user}
										readonly={this.props.readonlyForIndependentPermission}
									/>
								</div>
							}
						</Tab>
					}
					{this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee &&
						<Tab data-intercom-target={"menu-Employees-Records"} label={strings.Records} value="records">
							{this.state.tabActive === "records" &&
								<div className="user-details-data-tab">
									<UserDetailsRecord
										userId={this.props.user.Id}
									/>
								</div>
							}
						</Tab>
					}
					{(permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewUserDevices) ||
						this.props.loggedInUserType === AuthenticationStore.LoggedInUserTypes.Employee) &&
						<Tab data-intercom-target={"menu-Employees-Devices"} label={strings.Devices} value="devices">
							{this.state.tabActive === "devices" &&
								<UserDetailsDevice
									user={this.props.user}
									addDevicePermission={this.props.addDevicePermission}
									editDevicePermission={this.props.editDevicePermission}
									deleteDevicePermission={this.props.deleteDevicePermission}
								/>
							}
						</Tab>
					}
					{(permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewFile) ||
						this.props.loggedInUserType === ELoggedInUserType.Employee) &&
						<Tab data-intercom-target={"menu-Employees-Files"} label={strings.Files} value="files">
							{this.state.tabActive === "files" &&
								<div className="user-details-data-tab">
									<UserDetailsFiles
										userId={this.props.userId}
										loggedInUserType={this.props.loggedInUserType}
									/>
								</div>
							}
						</Tab>
					}
					{this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee &&
						<Tab data-intercom-target={"menu-Employees-FaceSpaces"} label={[<div key="top">{strings.face_spaces.split(" ")[0]}</div>, <div key="bottom">{strings.face_spaces.split(" ")[1]}</div>]} value="facespaces">
							{this.state.tabActive === "facespaces" &&
								<UserDetailsFaceSpaces
									user={this.props.user}
									onDeleteFaceSpaces={faceSpaceIds => {
										userActions.deleteFaceSpaces(this.props.user.Id, faceSpaceIds)
										this.setState({ tabActive: "facespaces" })
									}}
									onUpdateProfilePic={this.props.onUpdateProfilePic}
								/>
							}
						</Tab>
					}
					{AccountStore.getWorkAvailabilityEnabled() &&
						(permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewUserSchedule) ||
							this.props.loggedInUserType === AuthenticationStore.LoggedInUserTypes.Employee) &&
						<Tab data-intercom-target={"menu-Employees-WorkPref"} label={[<div key="top">{strings.Abbreviation_Work}</div>, <div key="bottom">{strings.Abbreviation_Preference}</div>]} value="workpreferences">
							{this.state.tabActive === "workpreferences" &&
								<UserDetailWorkPreferences
									user={this.props.user}
									scheduleStartDay={this.timecardStartDay}
									readonly={this.props.readonly && this.props.loggedInUserType !== ELoggedInUserType.Employee}
								/>
							}
						</Tab>
					}
				</Tabs>
			</Paper>
		)
	}
}